<template>
    <v-text-field v-model="fechaEdit" :label="label" placeholder="dd/mm/yyyy" hint="dia / mes / año" :error="!esFechaValida"
        @change="validarYFormatear" prepend-icon="mdi-calendar" :disabled="disabled" />
</template>
<script>
import moment from "moment";
import 'moment/locale/es';


export default {
    props: {
        label: { type: String, default: "Seleccione una fecha" },
        fecha: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        // format: { type: String, default: 'YMD' },
        // min: { type: String, default: "2000-01-01" },
        // max: { type: String, default: new Date().toISOString().substr(0, 10) },
    },
    data() {
        return {
            esFechaValida: true,
            fechaEdit: ''
        };
    },
   watch: {
        fecha: {
            handler(newValue) {
                const fechaM = moment(newValue);
                if (fechaM.isValid()) {
                    this.fechaEdit = fechaM.format("DD/MM/YYYY");
                }
            },
            immediate: true
        }
    },

    methods: {
        normalizarFecha(str) {
            if (!str || str.trim().split(/[/-]/).length != 3) return;
            const [d, m, a] = str.split(/[/-]/); // acepta '/' o '-'
            const dd = d.padStart(2, '0');
            const mm = m.padStart(2, '0');
            const yyyy = a.length === 2 ? '20' + a : a;
            return `${dd}/${mm}/${yyyy}`;
        },
        validarYFormatear() {

            if (!this.fechaEdit && !this.required) {
                this.esFechaValida = true;
                this.$emit("fecha", this.fechaEdit);
                return;
            }
            
            const fecha = moment(this.normalizarFecha(this.fechaEdit), ["DD/MM/YYYY"], true);


            this.esFechaValida = fecha.isValid();

            if (fecha.isValid()) {
                this.fechaEdit = fecha.format("DD/MM/YYYY");
                this.$emit("fecha", fecha.format('YYYY-MM-DD'));
            }

        },
    },
};
</script>
